import Material from "./Material"
import MaterialTypeEnum from "../../enums/MaterialTypeEnum";

// Wrapper for MaterialSet material. 
export default class SetMaterial extends Material {
    constructor() {
        super(MaterialTypeEnum.SetMaterial, 0);
    }
}

